import Kelly from '../assets/imagens/avatares/profissionais/KellyMendes.png'
import Thiago from '../assets/imagens/avatares/profissionais/ThiagoCedro.png'
import Ricamar from '../assets/imagens/avatares/profissionais/RicamarSantana.png'
import Matheus from '../assets/imagens/avatares/profissionais/MateusLima.png'
import Luis from '../assets/imagens/avatares/profissionais/RicamarSantana.png'
import Pedro from '../assets/imagens/avatares/profissionais/PedroMartins.png'
import Gutemberg from '../assets/imagens/avatares/profissionais/GutembergReboucas.png'
import MariaEduarda from '../assets/imagens/avatares/profissionais/MariaEduarda.png'
import Enzo from '../assets/imagens/avatares/profissionais/EnzoFrancisco.png'
import Julia from '../assets/imagens/avatares/profissionais/JuliaVidal.png'
import Vincci from '../assets/imagens/avatares/profissionais/VincciCarmides.png'
import Rodrigo from '../assets/imagens/avatares/profissionais/RodrigoSantana.png'
import Alexsandro from '../assets/imagens/avatares/profissionais/AlexsandroOliveira.png'
import Alaor from '../assets/imagens/avatares/profissionais/AlaorRibeiro.png'
import Persechini from '../assets/imagens/avatares/profissionais/LuizPersechini.png'
import Luciano from '../assets/imagens/avatares/profissionais/LucianoCardoso.png'
import LuisPaulo from '../assets/imagens/avatares/profissionais/LuisPaulo.png'

import humanoRobotico from '../assets/imagens/avatares/avatares2.0/humanoRobotico.png'
import essenciaHolografica from '../assets/imagens/avatares/avatares2.0/essenciaHolografica.png'
import forcaCibernetica from '../assets/imagens/avatares/avatares2.0/forcaCibernetica.png'
import menteAumentada from '../assets/imagens/avatares/avatares2.0/menteAumentada.png'
import identidadeDigital from '../assets/imagens/avatares/avatares2.0/identidadeDigital.png'
import mestreDasConexoes from '../assets/imagens/avatares/avatares2.0/mestreDasConexoes.png'
import energiaPura from '../assets/imagens/avatares/avatares2.0/energiaPura.png'
import guardiaoCorporativo from '../assets/imagens/avatares/avatares2.0/guardiaoCorporativo.png'
import sineticoPremium from '../assets/imagens/avatares/avatares2.0/sineticoPremium.png'

import humanoRobotico2 from '../assets/imagens/avatares/avatares2.0/border_radius/humanoRobotico.png'
import menteAumentada2 from '../assets/imagens/avatares/avatares2.0/border_radius/menteAumentada.png'
import identidadeDigital2 from '../assets/imagens/avatares/avatares2.0/border_radius/identidadeDigital.png'

export const avatares = [
    { nome: "Kelly Mendes", avatar: Kelly },
    { nome: "Thiago Cedro", avatar: Thiago },
    { nome: "Ricamar Santana", avatar: Ricamar },
    { nome: "Matheus Lima", avatar: Matheus },
    { nome: "Luis Belchior", avatar: LuisPaulo },
    { nome: "Pedro Martins", avatar: Pedro },
    { nome: "Gutemberg Reboucas", avatar: Gutemberg },
    { nome: "Maria Eduarda", avatar: MariaEduarda },
    { nome: "Enzo Francisco", avatar: Enzo },
    { nome: "Julia Vidal", avatar: Julia },
    { nome: "Vincci Carmides", avatar: Vincci },
    { nome: "Rodrigo Santana", avatar: Rodrigo },
    { nome: "Alexsandro Oliveira", avatar: Alexsandro },
    { nome: "Alaor Ribeiro", avatar: Alaor },
    { nome: "Luiz Persechini", avatar: Persechini },
    { nome: "Luciano Cardoso", avatar: Luciano }
];


export const avataresUsuarios = [
    { 
        avatar: "humanoRobotico", 
        imagem: humanoRobotico,
        imagemCirculo: humanoRobotico2
    
    },
    { avatar: "essenciaHolografica", imagem: essenciaHolografica, imagemCirculo: "" },
    { avatar: "forcaCibernetica", imagem: forcaCibernetica, imagemCirculo: "" },
    { avatar: "menteAumentada", imagem: menteAumentada, imagemCirculo: menteAumentada2 },
    { avatar: "identidadeDigital", imagem: identidadeDigital, imagemCirculo: identidadeDigital2 },
    { avatar: "mestreDasConexoes", imagem: mestreDasConexoes, imagemCirculo: "" },
    { avatar: "energiaPura", imagem: energiaPura, imagemCirculo: "" },
    { avatar: "guardiaoCorporativo", imagem: guardiaoCorporativo, imagemCirculo: "" },
    { avatar: "sineticoPremium", imagem: sineticoPremium, imagemCirculo: "" }
]


